import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as conversationItem from '../conversation-item'
import { Store } from '../store'
import * as workspaceItem from '../workspace-item'

@ngCore.Component({
  imports: [
    workspaceItem.Component,
    conversationItem.Component,
    ds.notice.Component,
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    ds.input.text.Component,
    ds.input.select.multiple.Component,
    ds.button.Component,
  ],
  selector: 'atn-workspace-tree',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
/**
 * Renders the full tree structure of workspaces and global conversations.
 */
export class Component {
  /**
   * Style enum exposed to HTML
   *
   * @see {@link ents.core.display.Style}
   */
  public readonly StyleEnum = ents.core.display.Style

  /**
   * Whether global conversations section is expanded
   */
  public isGlobalExpandedSg = ngCore.signal(true)

  /** @see {@link state.assistant.conversational.Group} */
  public readonly assistantGroup = ngCore.inject(
    state.assistant.conversational.Group,
  )

  /**
   * @see {@link Store}
   */
  public readonly store = ngCore.inject(Store)

  /**
   * Cancels workspace creation
   */
  public cancelCreateWorkspace(): void {
    this.assistantGroup.workspace.plugins.editingPlugin.feature.actions.discard
      .from('Dolomite.ChatPage.Workspace.Create.Cancelled')
      .dispatch({
        create: true,
        skipUnset: true,
      })
  }

  /**
   * Updates the workspace being created
   */
  public updateWorkspace(
    updates: Partial<state.assistant.conversational.workspace.Entity>,
  ): void {
    this.assistantGroup.workspace.plugins.editingPlugin.feature.actions.edit
      .from('Dolomite.ChatPage.Workspace.Create.Changed')
      .dispatch({
        edit: { input: updates },
      })
  }

  /**
   * Saves the new workspace
   */
  public saveWorkspace(): void {
    this.assistantGroup.workspace.plugins.editingPlugin.feature.actions.submit
      .from('Dolomite.ChatPage.Workspace.SaveButton.Clicked')
      .dispatch({
        create: true,
        skipUnset: true,
      })
  }
}
